<app-dialog-header [title]="commissionFee.id ? ('general.api_fees_' + (commissionFee.type | lowercase) + '_edit') : ('general.api_fees_' + (commissionFee.type | lowercase) + '_create')"
                   [withConfirm]="true" (closed)="confirmClose()"></app-dialog-header>
<div class="dialog-info" *ngIf="commissionFee.id">
  <div class="flex flex-wrap">
    <div class="label-value" *ngIf="targetCommissionLevel !== CommissionLevel.SuperCentre">
      <span class="label">{{ ('general.api_fees_' + (targetCommissionLevel | lowercase) + '_name') | translate }}:</span>
      {{ baseName | translateValue }}
    </div>
    <div class="label-value">
      <span class="label">{{'general.api_fees_fee_type' | translate}}:</span>
      {{ ('general.api_fees_' + (commissionFee.type | lowercase)) | translate }}
    </div>
  </div>
  <div class="flex flex-wrap" *ngIf="targetCommissionLevel === CommissionLevel.SuperCentre && commissionFee.currentPeriodPrice">
    <div class="label-value">
      <span class="label">{{ 'general.api_fees_current_fee_price' | translate }}:</span>
      {{ commissionFee.currentPeriodPrice.feePrice != null ? (commissionFee.currentPeriodPrice.feePrice | price) : (commissionFee.currentPeriodPrice.feePercent + '%') }}
    </div>
    <div class="label-value">
      <span class="label">{{ 'general.api_fees_current_period' | translate }}:</span>
      {{ commissionFee.currentPeriodPrice.period | period: {hasTimeInPeriod: true, threeDotsIfEmpty: true} }}
    </div>
  </div>
</div>
<mat-dialog-content class="flex flex-column">
  <app-text-input *ngIf="authService.user.isSuperCentre" [type]="TextInputType.Textarea"
                  [label]="'general.api_fees_comment'" [(value)]="commissionFee.comment" [max]="COMMENT_MAX_LENGTH"></app-text-input>
  <ng-container *ngIf="targetCommissionLevel !== CommissionLevel.SuperCentre">
    <div class="heading-5 no-margin">{{ 'general.api_fees_current_fee' | translate }}</div>
    <app-info-message *ngIf="!commissionFee.currentPeriodPrice" [icon]="'alert'" [message]="'general.api_fees_no_current_fee'"></app-info-message>
    <ng-container *ngIf="commissionFee.currentPeriodPrice">
      <div class="bordered-listing-wrapper" *ngIf="utilService.isMobile">
        <div class="listing-block" *ngIf="!isActivePeriodPrice(commissionFee.currentPeriodPrice.id)">
          <div class="header-block flex flex-center space-between bottom-spacer">
            <div>
              <div class="heading-5 no-margin text-base break-word bold">
                <span class="medium">{{ 'general.api_fees_price' | translate }}</span>
                {{ commissionFee.currentPeriodPrice.feePrice != null ? (commissionFee.currentPeriodPrice.feePrice | price) : (commissionFee.currentPeriodPrice.feePercent + '%') }}
              </div>
              <span class="text-muted body-3">{{ ('general.api_fees_commission_level_' + (commissionFee.currentPeriodPrice.level | lowercase)) | translate }}</span>
            </div>
            <div class="white-space-no-wrap no-grow no-min-width" *ngIf="commissionFee.currentPeriodPrice.level === targetCommissionLevel">
              <div class="flex flex-end">
                <button mat-button class="input-button icon-button" (click)="editPeriodPrice(commissionFee.currentPeriodPrice)" [disabled]="!!activePeriodPrice">
                  <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
                </button>
              </div>
            </div>
          </div>
          <table class="mobile-max-width mobile-columns">
            <tbody>
            <tr>
              <td class="medium">{{ 'general.api_fees_period_start' | translate }}</td>
              <td class="align-right">{{ commissionFee.currentPeriodPrice.period.start | moment: { withTime: true } }}</td>
            </tr>
            <tr>
              <td class="medium">{{ 'general.api_fees_period_end' | translate }}</td>
              <td class="align-right">{{ commissionFee.currentPeriodPrice.period.end ? (commissionFee.currentPeriodPrice.period.end | moment: { withTime: true }) : '...' }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <ng-container *ngIf="isActivePeriodPrice(commissionFee.currentPeriodPrice.id)" [ngTemplateOutlet]="activePeriodPriceMobileTemplate"></ng-container>
      </div>
      <table class="report-table" *ngIf="!utilService.isMobile">
        <thead>
        <tr>
          <th class="min-width">
            {{ 'general.api_fees_price' | translate }}
            <span class="subtitle">{{ 'general.api_fees_level' | translate }}</span>
          </th>
          <th>{{ 'general.api_fees_period_start' | translate }}</th>
          <th>{{ 'general.api_fees_period_end' | translate }}</th>
          <th class="min-width">&nbsp;</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <ng-container *ngIf="!isActivePeriodPrice(commissionFee.currentPeriodPrice.id)">
            <td class="white-space-no-wrap">
              {{ commissionFee.currentPeriodPrice.feePrice != null ? (commissionFee.currentPeriodPrice.feePrice | price) : (commissionFee.currentPeriodPrice.feePercent + '%') }}
              <br><small class="text-muted break-word">{{ ('general.api_fees_commission_level_' + (commissionFee.currentPeriodPrice.level | lowercase)) | translate }}</small>
            </td>
            <td>{{ commissionFee.currentPeriodPrice.period.start | moment: { withTime: true } }}</td>
            <td>{{ commissionFee.currentPeriodPrice.period.end ? (commissionFee.currentPeriodPrice.period.end | moment: { withTime: true }) : '...' }}</td>
            <td class="white-space-no-wrap">
              <button mat-button class="input-button icon-button" *ngIf="commissionFee.currentPeriodPrice.level === targetCommissionLevel"
                      (click)="editPeriodPrice(commissionFee.currentPeriodPrice)" [disabled]="!!activePeriodPrice">
                <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
              </button>
            </td>
          </ng-container>
          <ng-container *ngIf="isActivePeriodPrice(commissionFee.currentPeriodPrice.id)" [ngTemplateOutlet]="activePeriodPriceTemplate"></ng-container>
        </tr>
        </tbody>
      </table>
    </ng-container>

  </ng-container>
  <div class="heading-5 no-margin">
    {{ 'general.api_fees_fee_periods' | translate }}
    <mat-icon class="svg-icon text-grey" [svgIcon]="'info'" [matTooltip]="'general.api_fees_fee_tooltip' | translate"></mat-icon>
  </div>
  <app-info-message *ngIf="!commissionFee.futurePeriodPrices?.length"
                    [icon]="'alert'" [message]="'general.api_fees_no_records'"></app-info-message>
  <ng-container *ngIf="!!commissionFee.futurePeriodPrices?.length || (activePeriodPrice && !isCurrentPeriodPrice(activePeriodPrice.id, activePeriodPrice.feePeriod?.start))">
    <div class="bordered-listing-wrapper" *ngIf="utilService.isMobile">
      <ng-container *ngFor="let feePeriodPrice of commissionFee.futurePeriodPrices">
        <div class="listing-block" *ngIf="!isActivePeriodPrice(feePeriodPrice.id)">
          <div class="header-block flex flex-center space-between bottom-spacer">
            <div>
              <div class="heading-5 no-margin text-base break-word bold">
                <span class="medium">{{ 'general.api_fees_price' | translate }}</span>
                {{ feePeriodPrice.feePrice != null ? (feePeriodPrice.feePrice | price) : (feePeriodPrice.feePercent + '%') }}
              </div>
              <span class="text-muted body-3" *ngIf="targetCommissionLevel !== CommissionLevel.SuperCentre">
                {{ ('general.api_fees_commission_level_' + (feePeriodPrice.level | lowercase)) | translate }}
              </span>
            </div>
            <div class="white-space-no-wrap no-grow no-min-width" *ngIf="feePeriodPrice.level === targetCommissionLevel">
              <div class="flex flex-end decreased-margin">
                <button mat-button class="input-button icon-button" (click)="editPeriodPrice(feePeriodPrice)" [disabled]="!!activePeriodPrice">
                  <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
                </button>
                <button mat-button class="input-button icon-button" (click)="removePeriodPrice(feePeriodPrice.id)" [disabled]="!!activePeriodPrice || commissionFee.periodPrices.length === 1">
                  <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
                </button>
              </div>
            </div>
          </div>
          <table class="mobile-max-width mobile-columns">
            <tbody>
            <tr>
              <td class="medium">{{ 'general.api_fees_period_start' | translate }}</td>
              <td class="align-right">{{ feePeriodPrice.period.start | moment: { withTime: true } }}</td>
            </tr>
            <tr>
              <td class="medium">{{ 'general.api_fees_period_end' | translate }}</td>
              <td class="align-right">{{ feePeriodPrice.period.end ? (feePeriodPrice.period.end | moment: { withTime: true }) : '...' }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <ng-container *ngIf="isActivePeriodPrice(feePeriodPrice.id)" [ngTemplateOutlet]="activePeriodPriceMobileTemplate"></ng-container>
      </ng-container>
      <ng-container *ngIf="isPeriodCreate" [ngTemplateOutlet]="activePeriodPriceMobileTemplate"></ng-container>
    </div>
    <table class="report-table" *ngIf="!utilService.isMobile">
      <thead>
      <tr>
        <th class="min-width">
          {{ 'general.api_fees_price' | translate }}
          <span class="subtitle" *ngIf="targetCommissionLevel !== CommissionLevel.SuperCentre">
            {{ 'general.api_fees_level' | translate }}
          </span>
        </th>
        <th *ngIf="targetCommissionLevel === CommissionLevel.SuperCentre">{{ 'general.api_fees_period' | translate }}</th>
        <ng-container *ngIf="targetCommissionLevel !== CommissionLevel.SuperCentre">
          <th>{{ 'general.api_fees_period_start' | translate }}</th>
          <th>{{ 'general.api_fees_period_end' | translate }}</th>
        </ng-container>
        <th class="min-width">&nbsp;</th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngFor="let feePeriodPrice of commissionFee.futurePeriodPrices">
        <tr>
          <ng-container *ngIf="!isActivePeriodPrice(feePeriodPrice.id)">
            <td class="white-space-no-wrap">
              {{ feePeriodPrice.feePrice != null ? (feePeriodPrice.feePrice | price) : (feePeriodPrice.feePercent + '%') }}
              <ng-container *ngIf="targetCommissionLevel !== CommissionLevel.SuperCentre">
                <br><small class="text-muted break-word">{{ ('general.api_fees_commission_level_' + (feePeriodPrice.level | lowercase)) | translate }}</small>
              </ng-container>
            </td>
            <td *ngIf="targetCommissionLevel === CommissionLevel.SuperCentre">
              {{ feePeriodPrice.period | period: {hasTimeInPeriod: true, threeDotsIfEmpty: true} }}
            </td>
            <ng-container *ngIf="targetCommissionLevel !== CommissionLevel.SuperCentre">
              <td>{{ feePeriodPrice.period.start | moment: { withTime: true } }}</td>
              <td>{{ feePeriodPrice.period.end ? (feePeriodPrice.period.end | moment: { withTime: true }) : '...' }}</td>
            </ng-container>
            <td class="white-space-no-wrap decreased-margin" [ngClass]="{'flex': feePeriodPrice.level === targetCommissionLevel}">
              <ng-container *ngIf="feePeriodPrice.level === targetCommissionLevel">
                <button mat-button class="input-button icon-button" (click)="editPeriodPrice(feePeriodPrice)" [disabled]="!!activePeriodPrice">
                  <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
                </button>
                <button mat-button class="input-button icon-button" (click)="removePeriodPrice(feePeriodPrice.id)" [disabled]="!!activePeriodPrice || commissionFee.periodPrices.length === 1">
                  <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
                </button>
              </ng-container>
            </td>
          </ng-container>
          <ng-container *ngIf="isActivePeriodPrice(feePeriodPrice.id)"
                        [ngTemplateOutlet]="activePeriodPriceTemplate"></ng-container>
        </tr>
      </ng-container>
      <tr *ngIf="isPeriodCreate">
        <ng-container [ngTemplateOutlet]="activePeriodPriceTemplate"></ng-container>
      </tr>
      </tbody>
    </table>
  </ng-container>
  <app-link [link]="'general.api_fees_add_period_price_' + (targetCommissionLevel | lowercase)" [icon]="'plus'"
            (linkClicked)="addPeriodPrice()" [disabled]="!!activePeriodPrice"></app-link>
  <br>
</mat-dialog-content>
<ng-template #activePeriodPriceMobileTemplate>
  <div class="listing-block">
    <div class="header-block flex flex-top space-between bottom-spacer">
      <div>
        <div class="heading-5 no-margin text-base break-word bold">
          <span class="medium">{{ 'general.api_fees_price' | translate }}</span>
          <ng-container *ngIf="!isCurrentPeriodPrice(activePeriodPrice.id, activePeriodPrice.feePeriod?.start)"
                        [ngTemplateOutlet]="activePricePercentageInput"></ng-container>
          <ng-container *ngIf="isCurrentPeriodPrice(activePeriodPrice.id, activePeriodPrice.feePeriod?.start)">
            {{ activePeriodPrice.feeType === 'price' ? ((activePeriodPrice.feeValue*100) | price) : (activePeriodPrice.feeValue + '%') }}
          </ng-container>
        </div>
        <span class="text-muted body-3" *ngIf="isCurrentPeriodPrice(activePeriodPrice.id, activePeriodPrice.feePeriod?.start)">
          {{ ('general.api_fees_commission_level_' + (commissionFee.currentPeriodPrice.level | lowercase)) | translate }}
        </span>
      </div>
      <div class="white-space-no-wrap no-grow no-min-width">
        <div class="flex flex-end decreased-margin">
          <button mat-button class="input-button filter-button icon-button" (click)="savePeriodPrice()" [disabled]="!canSavePeriodPrice">
            <mat-icon class="svg-icon" [svgIcon]="'save'"></mat-icon>
          </button>
          <button mat-button class="input-button filter-button icon-button" (click)="clearActivePeriodPrice()">
            <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <table class="mobile-max-width mobile-columns">
      <tbody>
      <tr>
        <td class="medium">{{ 'general.api_fees_period_start' | translate }}</td>
        <td class="align-right">&nbsp;
          <ng-container *ngIf="isCurrentPeriodPrice(activePeriodPrice.id, activePeriodPrice.feePeriod?.start)">
            {{ activePeriodPrice.feePeriod.start | moment: { withTime: true } }}
          </ng-container>
        </td>
      </tr>
      <tr *ngIf="!isCurrentPeriodPrice(activePeriodPrice.id, activePeriodPrice.feePeriod?.start)">
        <td [colSpan]="2" class="max-width"><ng-container [ngTemplateOutlet]="activeStartDateInput"></ng-container></td>
      </tr>
      <ng-container *ngIf="targetCommissionLevel !== CommissionLevel.SuperCentre">
        <tr>
          <td [colSpan]="2" class="medium">{{ 'general.api_fees_period_end' | translate }}</td>
        </tr>
        <tr>
          <td [colSpan]="2" class="max-width" [ngClass]="{'valign-middle': !showEndDatepicker}">
            <ng-container [ngTemplateOutlet]="activeEndDateInput"></ng-container>
          </td>
        </tr>
      </ng-container>
      </tbody>
    </table>
  </div>
</ng-template>
<ng-template #activePeriodPriceTemplate>
  <td class="min-width white-space-no-wrap">
    <ng-container *ngIf="isCurrentPeriodPrice(activePeriodPrice.id, activePeriodPrice.feePeriod?.start)">
      {{ activePeriodPrice.feeType === 'price' ? ((activePeriodPrice.feeValue*100) | price) : (activePeriodPrice.feeValue + '%') }}
    </ng-container>
    <ng-container *ngIf="!isCurrentPeriodPrice(activePeriodPrice.id, activePeriodPrice.feePeriod?.start)"
                  [ngTemplateOutlet]="activePricePercentageInput"></ng-container>
  </td>
  <td class="limited-width">
    <ng-container *ngIf="isCurrentPeriodPrice(activePeriodPrice.id, activePeriodPrice.feePeriod?.start)">
      {{ activePeriodPrice.feePeriod.start | moment: { withTime: true } }}
    </ng-container>
    <ng-container *ngIf="!isCurrentPeriodPrice(activePeriodPrice.id, activePeriodPrice.feePeriod?.start)"
                  [ngTemplateOutlet]="activeStartDateInput"></ng-container>
  </td>
  <td class="limited-width" [ngClass]="{'valign-middle': !showEndDatepicker}" *ngIf="targetCommissionLevel !== CommissionLevel.SuperCentre">
    <ng-container [ngTemplateOutlet]="activeEndDateInput"></ng-container>
  </td>
  <td class="white-space-no-wrap align-right">
    <button mat-button class="input-button filter-button icon-button right-spacer-half" (click)="savePeriodPrice()"
            [disabled]="!canSavePeriodPrice">
      <mat-icon class="svg-icon" [svgIcon]="'save'"></mat-icon>
    </button>
    <button mat-button class="input-button filter-button icon-button" (click)="clearActivePeriodPrice()">
      <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
    </button>
  </td>
</ng-template>
<ng-template #activePricePercentageInput>
  <app-numeric-input [appClass]="'prefix-field compact'"
                     [(value)]="activePeriodPrice.feeValue" [withSuffix]="true" [required]="true"
                     [hideSymbol]="true" [type]="activePeriodPrice.feeType" [allowPercentageDecimalPlaces]="true">
    <mat-form-field appearance="outline" class="with-prefix no-hint compact">
      <mat-select [(ngModel)]="activePeriodPrice.feeType" [ngModelOptions]="{standalone: true}">
        <mat-option [value]="'percentage'">{{ '%' }}</mat-option>
        <mat-option [value]="'price'">{{ authService.currencySymbol }}</mat-option>
      </mat-select>
    </mat-form-field>
  </app-numeric-input>
</ng-template>
<ng-template #activeStartDateInput>
  <app-datepicker *ngIf="targetCommissionLevel === CommissionLevel.Event"
                  [datePickerConfig]="eventStartDatePickerConfig" [timezone]="authService.user.timezone" [(date)]="activePeriodPrice.feePeriod.start"
                  [required]="true" [valid]="isPeriodStartValid" (dateTimeChanged)="validatePeriodStart()"></app-datepicker>
  <app-datepicker *ngIf="targetCommissionLevel !== CommissionLevel.Event"
                  [datePickerConfig]="datePickerConfig" [timezone]="authService.user.timezone" [(date)]="activePeriodPrice.feePeriod.start"
                  [required]="true" [valid]="isPeriodStartValid" (dateTimeChanged)="validatePeriodStart()"></app-datepicker>
</ng-template>
<ng-template #activeEndDateInput>
  <app-link class="table-icon-link" *ngIf="!showEndDatepicker" [link]="'general.api_fees_add_period_end'" [icon]="'plus'" (linkClicked)="setDefaultEndDate()"
            [disabled]="!activePeriodPrice.feePeriod?.start"></app-link>
  <app-datepicker *ngIf="showEndDatepicker" [datePickerConfig]="datePickerConfig" [timezone]="authService.user.timezone" [(date)]="activePeriodPrice.feePeriod.end"
                  [minDate]="minEndDate || activePeriodPrice.feePeriod.start" [disabled]="!activePeriodPrice.feePeriod?.start"
                  [valid]="isPeriodEndValid" (dateTimeChanged)="validatePeriodEnd()"></app-datepicker>
</ng-template>
<app-dialog-footer [dialogActions]="feeDialogButtons"></app-dialog-footer>
<ng-template #feeDialogButtons>
  <div class="flex flex-end max-width flex-mobile">
    <div class="flex-mobile">
      <button mat-button (click)="confirmClose()">{{ 'general.api_general_cancel' | translate }}</button>
      <button mat-flat-button color="primary" (click)="saveFee()" [disabled]="!canSaveFee">
        {{ (commissionFee.id ? 'general.api_fees_save' : 'general.api_fees_create') | translate }}
      </button>
    </div>
  </div>
</ng-template>
<app-loader [loading]="isLoading" [overlay]="true"></app-loader>
